import { render, staticRenderFns } from "./RemoveContractorIcon.vue?vue&type=template&id=26211070"
import script from "./RemoveContractorIcon.vue?vue&type=script&lang=ts"
export * from "./RemoveContractorIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports